import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const QUICK_LINKS_TILE_HEIGHT = '5rem';

export const QuickLinksGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 0.25rem;
`;

const tileStyles = css`
	display: flex;
	justify-content: space-between;
	min-height: ${QUICK_LINKS_TILE_HEIGHT};
	padding: 1.125rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};
	text-decoration: none;

	.quick-links-right {
		align-items: flex-end;
	}

	.icon-badge {
		margin-bottom: 0.5rem;
		flex-shrink: 0;
		color: ${({ theme }) => theme.v3.colors.dark[8]};
	}

	.total-count {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 1.5rem;
		border-radius: 1rem;
		padding: 0 0.5rem;
		background: ${({ theme }) => theme.v3.colors.gray[4]};
		color: ${({ theme }) => theme.v3.colors.dark[8]};

		> * {
			line-height: 1;
		}
	}
`;

export const QuickLinkTile = styled.div`
	${tileStyles}
`;

export const QuickLinkTileLink = styled(Link)`
	${tileStyles}

	&:hover {
		border-color: ${({ theme }) => theme.v3.colors.blue[6]};
	}
`;
